import {
  getLocalStorageToken,
  removeLocalStorageToken,
  setLocalStorage,
} from '../../store/localStorage'

export const LOGIN_UPDATE_TOKEN = 'LOGIN_UPDATE_TOKEN'
export const LOGIN_SUBMIT = 'LOGIN_SUBMIT'
export const LOGIN_ERROR = 'LOGIN_ERROR'
export const LOGIN_REMOVE_TOKEN = 'LOGIN_REMOVE_TOKEN'

export interface ILoginState {
  loggingIn: boolean
  loginError: boolean
  token: string
}

const initialState: ILoginState = {
  loggingIn: false,
  loginError: false,
  token: '',
}
export function loginReducer(state: ILoginState = initialState, action: any): ILoginState {
  switch (action.type) {
    case LOGIN_REMOVE_TOKEN:
      removeLocalStorageToken()
      return { ...state, token: '' }
    case LOGIN_UPDATE_TOKEN:
      setLocalStorage('token', action.payload)
      return { ...state, loggingIn: false, loginError: false, token: action.payload }
    case LOGIN_SUBMIT:
      return { ...state, loggingIn: true, loginError: false }
    case LOGIN_ERROR:
      return { ...state, loggingIn: false, loginError: true }
    default:
      return getLocalStorageToken() && !state.token
        ? { ...state, token: getLocalStorageToken() }
        : state
  }
}
